import { render, staticRenderFns } from "./updateuserinfoModal_backup.vue?vue&type=template&id=11c28c28&scoped=true"
import script from "./updateuserinfoModal_backup.vue?vue&type=script&lang=js"
export * from "./updateuserinfoModal_backup.vue?vue&type=script&lang=js"
import style0 from "./updateuserinfoModal_backup.vue?vue&type=style&index=0&id=11c28c28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c28c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c28c28')) {
      api.createRecord('11c28c28', component.options)
    } else {
      api.reload('11c28c28', component.options)
    }
    module.hot.accept("./updateuserinfoModal_backup.vue?vue&type=template&id=11c28c28&scoped=true", function () {
      api.rerender('11c28c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/updateuserinfoModal_backup.vue"
export default component.exports